import { createSelector } from 'reselect';
 
const selectMemberships = (state: any) => state.memberships;
 
export const selectMembershipsCurrentItem = createSelector([selectMemberships], (memberships) => memberships.current);
 
export const selectMembershipsListItems = createSelector([selectMemberships], (memberships) => memberships.list);
 
 
export const selectMembershipsItemById = (itemId: any) =>
    createSelector(selectMembershipsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));
 
export const selectMembershipsQueryItems = createSelector([selectMemberships], (memberships) => memberships.query);

export const selectMembershipsCreatedItem = createSelector([selectMemberships], (memberships) => memberships.create);
 
export const selectMembershipsUpdatedItem = createSelector([selectMemberships], (memberships) => memberships.update);
 
export const selectMembershipsReadItem = createSelector([selectMemberships], (memberships) => memberships.read);
 
export const selectMembershipsDeletedItem = createSelector([selectMemberships], (memberships) => memberships.delete);
 
export const selectMembershipsSearchedItems = createSelector([selectMemberships], (memberships) => memberships.search);
 
export const selectMembershipsItemsCount = createSelector([selectMemberships], (memberships) => memberships.count);
 
export const selectMembershipsItemsFilter = createSelector([selectMemberships], (memberships) => memberships.filter);